import '../common/eshop'
import '../common/window'
import '../common/cookiebot-refresh';
import '../components/modal/modal-back'
import '../components/modal/modal-jump'
import '../components/zasielkovna'
import '../../../vendor/rshop/frontend/resources/js/ui/ui_spinner'
import '../common/info-messages'
import '../common/toggle-password'
import { updateLazy } from '../functions/lazy'
import { initTippy } from '../functions/tippy';

window.Cart.customCallbacks.addedItem = function(form, response) {
    window.rEvent.dispatch('Custom.Cart.addedItem', {form, response})
}
window.Cart.customCallbacks.updatedItem = function(input, response) {
    window.rEvent.dispatch('Custom.Cart.updatedItem', {input, response})
}
window.Cart.customCallbacks.removedItem = function(form, response) {
    window.rEvent.dispatch('Custom.Cart.removedItem', {form, response})
}

updateLazy();
initTippy();

const wannaRegInput = document.querySelector('#customer-registered');

function toggleNotVatPayer(wannaReg) {
    const notVatInputHolder = document.querySelector('.js-not-vat-payer-wrapper'),
        notVatInput = notVatInputHolder.querySelector('[name="custom_not_vat_payer"]');

    if (wannaReg) {
        notVatInputHolder.classList.remove('hidden');
    }
    else {
        notVatInput.checked = false;
        notVatInputHolder.classList.add('hidden');
    }
}

if (wannaRegInput) {
    rEvent.on('Form.CompanyToggle.changed', () => {
        toggleNotVatPayer(wannaRegInput.checked);
    });

    wannaRegInput.addEventListener('change', () => {
        toggleNotVatPayer(wannaRegInput.checked);
    });
}